import { SxProps, Theme } from "@mui/material";

export const patientCardContainer: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  flexShrink: 0,
  alignSelf: "stretch",
  width: "100%",
};
